import {FaPlus} from "react-icons/fa";
import Button from "../../../../components/button/button";
import {Template} from "../../../../components/template/template";
import {Card} from "../../../../components/card/card";
import InputForm from "../../../../components/input/input-form";
import {navigateHook} from "../../../../hooks/use-navigate";
import {useParams} from "react-router";
import {useEffect, useState} from "react";
import {useMutation, useQuery} from "@tanstack/react-query";
import EquipmentsService from "../../../../services/web/equipments-service";
import ProjectUtils from "../../../../utils/project-utils";
import Swal from "sweetalert2";
import projectUtils from "../../../../utils/project-utils";
import Alert from "../../../../components/alert/alert.jsx";

export default function EquipmentsForm() {
    const navigate = navigateHook();

    const { id } = useParams();
    const [state, setState] = useState({});

    const { data, isLoading, refetch} = useQuery({
        queryKey: ['equipments-form-data', id],
        enabled: !!id,
        queryFn: () => EquipmentsService.getById(id),
    });

    useEffect(() => {
        if (data?.data) setState(data.data);
    }, [data]);

    const onChange = ({ target: { value, id } }) => setState(prev => ({ ...prev, [id]: value}));

    const saveMutation = useMutation({
        mutationFn: async () => {
            const payload = { description: (state.description ?? "").trim() };
            return id ? EquipmentsService.update(id, payload) : EquipmentsService.create(payload);
        },
        onSuccess: (data) => {
            ProjectUtils.success(!id);

            if (!id) {
                const newId = data?.data?.id;

                const urlDev = `/equipments/form/${newId}`;
                navigate(urlDev);
                return;
            }
            refetch?.();
        },
        onError: (error) => {
            console.error(error);
            let errMessage = "Não foi possível salvar.";
            if (error.response.data.message === "name.already.used") errMessage = "Este \"Nome\" já está sendo utilizado."
            if (!String(state.description ?? '').trim()) errMessage = "O campo \"Nome\" é obrigatório.";

            projectUtils.swalErrorMessage("", errMessage, "Ok");
        },
    });

    const handleDelete = () => {
        if (!id) return;

        Swal.fire({
            title: "Excluir",
            text: `Excluir o equipamento "${state.description}"?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#063A6C",
            confirmButtonText: "Sim",
            cancelButtonColor: "#c10007",
            cancelButtonText: "Não",
            reverseButtons: true,
        }).then((result) => {
            if (result.isConfirmed) {
                return EquipmentsService.delete(id).then(() => {
                    projectUtils.success(true, "Excluído com sucesso");
                    navigateToList();
                })
                .catch((err) => {
                    console.error(err);
                    const msg = err?.response?.data?.message ?? "Não foi possível excluir.";
                    ProjectUtils.swalErrorMessage("", msg, "Ok");
                })
            };
        })
    };

    const navigateToList = () => {
        const urlDev = "/equipments";
        navigate(urlDev);
    };

    const newEquipment = () => {
        setState({ description: "" });
        const urlDev = "/equipments/form";
        navigate(urlDev);
    };

    return(
        <Template isLoading={isLoading}>
            <Template.Header>
                <Template.Title>Equipamento de zeladoria</Template.Title>
                {id && (
                    <Button target="primary-outline" onClick={newEquipment}><FaPlus />Adicionar equipamento</Button>
                )}
            </Template.Header>
            <Template.Body className="space-y-2">
                <Card>
                    <Card.Body>
                        <div className="flex gap-4">
                            <InputForm 
                                id="description"
                                label="Nome *"
                                value={state.description ?? ""}
                                onChange={onChange}
                                classNameWrapper="flex-1"
                            />
                        </div>
                    </Card.Body>
                </Card>
                <Card>
                    <Card.Body>
                        <div className="flex gap-2 justify-end items-center">
                            {id && !data?.data?.canDelete && (
                            <Alert target="warning">Não é possível excluir, pois existem solicitações dependentes do equipamento.</Alert>
                            )}
                            {id && (
                            <Button 

                                target="danger"
                                disabled={!data?.data?.canDelete}
                                onClick={handleDelete}
                             actionFeedbackType='delete'>
                                Excluir
                            </Button>
                            )}
                            <Button

                                onClick={() => saveMutation.mutate()}
                             actionFeedbackType='save'>Salvar</Button>
                        </div>
                    </Card.Body>
                </Card>
            </Template.Body>
        </Template>
    )
}